<template>
  <div>
    <FilePopup
      v-if="isFilePriview"
      v-bind:filedata="filePriviewData"
      @closePopup="closePopup"
    ></FilePopup>
    <div class="w-full sm_star" v-if="!isFilePriview">
      <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
      <div class="sm_header">
        <h1>{{ $t("1427") }}</h1>
        <button class="menu_btn" @click="openDrawer()">
          <span>mobile menu</span>
        </button>
        <div class="search_box">
          <input
            type="text"
            placeholder="검색어를 입력해주세요."
            class="search_form"
            onkeydown="if (event.keyCode == 13) {search();}"
            v-model="contents"
          />
          <button type="button" class="search_close" @click="searchClose()">
            검색 닫기
          </button>
          <button type="button" class="search_btn" @click="search()">
            검색
          </button>
        </div>
      </div>

      <!-- content -->
      <div class="sm_wrap">
        <div
          class="mdc-tab-bar view-tab-bar abcd"
          role="tablist"
          id="learnViewTab"
          ref="learnViewTab"
          style="position: fixed; left: 0; top: 55px; z-index: 3; padding: none"
        >
          <div class="mdc-tab-scroller">
            <div
              class="mdc-tab-scroller__scroll-area mdc-tab-scroller__scroll-area--scroll mgb-000"
            >
              <div class="mdc-tab-scroller__scroll-content">
                <button
                  class="mdc-tab"
                  :class="{ 'mdc-tab--active': board.identifier == boardId }"
                  v-for="(board, i) in boards"
                  role="tab"
                  :tabindex="i"
                  @click="changeTabType(i, board.identifier)"
                  :key="board.id"
                  :to="`#${board.name}`"
                >
                  <span class="mdc-tab__content">
                    <span class="mdc-tab__text-label">
                      {{ board.name }}
                    </span>
                  </span>
                  <!-- this.boardId :class="{'mdc-tab-indicator--active':(i==0)}"-->
                  <span
                    class="mdc-tab-indicator"
                    :class="{
                      'mdc-tab-indicator--active': board.identifier == boardId,
                    }"
                  >
                    <span
                      class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"
                    ></span>
                  </span>
                  <span class="mdc-tab__ripple mdc-ripple-upgraded"></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="sm_list learning">
          <div class="user_fixed">
            <!-- userbox -->
            <div class="user_box align-items-center" v-if="mamberData">
              <div
                :style="
                  mamberData.profile
                    ? `background-image: url(${mamberData.profile});`
                    : `background-image: url('images/avatar_image.png');`
                "
                class="overflow-visible drawer-profile-logo user_img"
                @click="
                  priviewFiel({
                    contentType: 'image',
                    resourceUri: mamberData.profile
                      ? mamberData.profile
                      : 'images/avatar_image.png',
                  })
                "
              >
                <ProfileTier
                  v-if="
                    mamberData.tier &&
                    mamberData.tier.image &&
                    mamberData.tier.image.resourceUri
                  "
                  :data="mamberData"
                  :className="'mgl-4 size-18'"
                />
              </div>
              <div class="user_txt user-name-wrapper d-flex t-line-h-1em">
                <div class="name top-name">
                  <div class="name name-ellipsis mgr-4 position-relative top-2">
                    {{ mamberData.name ? mamberData.name.last + ' ' + mamberData.name.first : '' }}
                  </div>
                  <ProfileTierName
                    v-if="mamberData.tier"
                    :data="mamberData"
                    :className="'d-inline position-relative bottom-2'"
                  />
                </div>
                <!-- <p class="date">{{ mamberData.storeName }} | {{ mamberData.responsibilityName }}</p> -->
              </div>

              <div class="user_write">
                <router-link
                  :to="'/socialLearning?bId=' + boardId"
                  class="write_btn me"
                >
                  {{ $t("3061") }}</router-link
                >
                <!-- <router-link :to="{name: 'SLWrite'}" class="write_btn" v-if="selectedChild && selectedChild.register === true" >{{ $t('1429') }}</router-link> -->
                <a
                  class="write_btn"
                  @click="changeRoute"
                  v-if="selectedChild && selectedChild.register === true"
                  >{{ $t("1429") }}</a
                >
                <!--<a href="#" class="write_btn"></a>-->
              </div>
            </div>
            <!-- //userbox -->
          </div>

          <div class="sm_list_box">
            <SocialLearningNoData v-if="isNoData"></SocialLearningNoData>
            <!-- list-->
            <div
              class="list_box"
              v-for="(record, index) in listData"
              :key="index"
            >
              <div @click="moveToDetail(record)">
                <div class="user_box d-flex">
                  <div
                    class="overflow-visible user_img"
                    :style="
                      record.auditor.register.profile
                        ? `background: url(${record.auditor.register.profile}) center;`
                        : `background: url('images/avatar_image.png') center;`
                    "
                  >
                    <ProfileTier
                      v-if="
                        record.auditor.register.tier &&
                        record.auditor.register.tier.image &&
                        record.auditor.register.tier.image.resourceUri
                      "
                      :data="record.auditor.register"
                      :className="'mgl-4 size-18'"
                    />
                  </div>
                  <div class="user_txt">
                    <div class="name">
                      <div class="name">
                        {{
                          record.auditor.register.name
                            ? record.auditor.register.name.fullName
                            : $t("S10082")
                        }}
                      </div>
                      <ProfileTierName
                        v-if="record.auditor.register.tier"
                        :data="record.auditor.register"
                      />
                    </div>
                    <p v-show="record.auditor.register.storeName" class="date">
                      {{ record.auditor.register.storeName }} |
                      {{ record.auditor.register.responsibilityName }}
                    </p>
                    <p style="font-size: 12px" class="date">
                      {{
                        $moment(record.auditor.register.time).format(
                          "YYYY.MM.DD"
                        )
                      }}
                    </p>
                  </div>
                </div>
                <!-- //userbox -->

                <div
                  class="user_con"
                  v-if="record.contents && record.contents.body !== ''"
                >
                  <span v-html="listFilter(record.contents.body)"></span>
                </div>

                <div
                  class="user_tag"
                  v-if="record.tags && record.tags.length > 0"
                >
                  <span v-for="(tag, i) in record.tags" :key="i"
                    >#{{ tag.name }}</span
                  >
                </div>
                <!-- <pre>
              {{ record.contents.images }}
              </pre>-->
                <div
                  class="user_imgList"
                  v-if="record.contents.images.length > 2"
                >
                  <a href="#">
                    <img :src="record.contents.images[0].resourceUri" alt />
                  </a>
                  <a href="#">
                    <img
                      v-if="record.contents.images[1]"
                      :src="record.contents.images[1].resourceUri"
                      alt
                    />
                  </a>
                  <a href="#" class="more">
                    <img
                      v-if="record.contents.images[2]"
                      :src="record.contents.images[2].resourceUri"
                      alt
                    />
                    <span>+2</span>
                  </a>
                </div>

                <div
                  class="user_imgList"
                  v-if="record.contents.images.length == 2"
                >
                  <a
                    href="#"
                    v-for="(img, index1) in record.contents.images"
                    :key="index1"
                    style="width: 48%; height: 115px; padding-top: 32%"
                  >
                    <img :src="img.resourceUri" alt />
                  </a>
                </div>
                <div
                  class="user_imgList"
                  v-if="record.contents.images.length == 1"
                >
                  <a href="#" style="width: 100%; padding-top: 100%">
                    <img :src="record.contents.images[0].resourceUri" alt />
                  </a>
                </div>
              </div>
              <!-- <div class="user_opt">
                {{ $t("1430", { str: record.likesCount }) }} &nbsp;&nbsp;
                {{ $t("1431", { str: record.commentCount }) }}
                <span class="right">{{
                  $t("1432", { str: record.viewCount })
                }}</span>
              </div> -->
            </div>
            <!-- //list-->

            <infinite-loading
              @infinite="fetchData"
              :identifier="infiniteId"
              spinner="spiral"
            >
              <div slot="no-more" class="mgt-16">No more data</div>
              <div slot="no-results" class="mgt-16"></div>
            </infinite-loading>
          </div>
        </div>
      </div>
      <!-- //content -->
    </div>
  </div>
</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(social learning list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import { MDCTabBar } from "@material/tab-bar";
import socialApi from "@/api/socialApi.js";
import SocialLearningNoData from "./SocialLearningNoData.vue";
import InfiniteLoading from "vue-infinite-loading";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import FilePopup from "./FilePopup";
import ProfileTierName from "../common/ProfileTierName.vue";
import ProfileTier from "../common/ProfileTier.vue";

export default {
  components: {
    SocialLearningNoData,
    InfiniteLoading,
    //TopAppBar,
    TopAppBarDrawer,
    FilePopup,
    ProfileTierName,
    ProfileTier,
    ProfileTierName,
  },
  data: function () {
    return {
      isDrawerOpen: false,
      mamberData: [],
      contents: "",
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      filePriviewData: [],
      isFilePriview: false,
      selectedChild: null,
      boardId: null,
      boardData: null,
      boards: [],
    };
  },
  mixins: [topAppBarMixin],
  watch: {
    $route(to, from) {
      this.initData();
    },
  },
  mounted() {
    this.boardId = this.$route.query.bId;
    socialApi
      .boardAuth(this.boardId)
      .then((response) => {
        this.boardData = response.data.data;
        socialApi
          .fetchMember()
          .then((response) => {
            this.mamberData = response.data.data;
            let myId = this.mamberData.responsibilityId;
            let permissionData = this.boardData.authPermission.find(
              (child) => child.partId == myId
            );
            if (permissionData) {
              this.selectedChild = permissionData;
            }
          })
          .catch((err) => {
            $state.error();
          });
      })
      .catch((err) => {
        $state.error();
      });

    let bid = this.$route.query.bId;
    socialApi.bordList({ bid }).then((response) => {
      this.boards = response.data.data.filter((arr) => arr.boardAuth == true);
      if (bid) {
        let ti = this.boards.findIndex(
          (arr) => arr.identifier.toLowerCase() == bid.toLowerCase()
        );
        this.boardId = bid;
        this.learnViewTab = new MDCTabBar(
          document.querySelector("#learnViewTab")
        );
        this.learnViewTab.activateTab(ti);
        this.changeTabType(ti, this.boards[ti].identifier); //for auto-activate first tab
      } else {
        this.boardId = this.boards[0].identifier;
      }
    });
  },
  methods: {
    changeRoute() {
      if (this.boardData && this.boardData.userBbsToDayAuth) {
        this.$router.push("/social-learning/write?bId=" + this.boardId);
      } else {
        this.$alert({
          //title: this.$t('779'), //가입 승인 대기 상태입니다.
          content: this.$t("3064"),
          accept: this.$t("3065"),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    priviewFiel(file) {
      this.filePriviewData = file;
      this.isFilePriview = true;
    },
    closePopup() {
      this.filePriviewData = Array();
      this.isFilePriview = false;
    },
    listFilter(str) {
      let length = 160;
      let ending = " ...";
      let str1 = "";
      if (str.length > length) {
        str1 = str.substring(0, length - ending.length) + ending;
        return str1.replace(/(\r\n|\n|\r)/gm, "<br/>");
      } else {
        return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
      }
    },
    // method to redirect the user on Detail page if exists
    moveToDetail(record) {
      if (record && record.id) {
        this.$router.push(
          "/socialLearning/" +
            record.id +
            "?bId=" +
            this.boardId +
            "&portfolio=social-mypost"
        );
        // this.$router.push({
        //   name: "SLDetail",
        //   params: {
        //     postId: record.id
        //   }
        // });
      }
    },
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();
      if (this.totalPages >= this.currentPage) {
        socialApi
          .fetchList(params, this.boardId)
          .then((response) => {
            responseData = response.data.data;
            _.map(responseData.content, (o) => {
              o.progressViewStatus = false;
            });

            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;
            if (responseData.content.length) {
            }
            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      let params = {
        type: "MINE",
        sort: "id,desc",
        //contents: encodeURI(this.contents),
        page: this.currentPage,
      };
      return params;
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    searchOpen() {
      $(".search_box").show();
      $(".sm_star").addClass("backBg");
    },
    searchClose() {
      $(".search_box").hide();
      $(".sm_star").removeClass("backBg");
    },
    search() {
      let responseData = null;
      let params = this.setParams();
      socialApi
        .fetchList(params)
        .then((response) => {
          responseData = response.data.data;
          // _.map(responseData.content, (o) => {
          //   o.progressViewStatus = false;
          // });

          this.listData = responseData.content;

          $(".search_box").hide();
          $(".sm_star").removeClass("backBg");
        })
        .catch((err) => {
          $(".search_box").hide();
          $(".sm_star").removeClass("backBg");
          $state.error();
        });
    },
    patchLikeState(id, status) {
      this.$showLoading();

      let action = status
        ? socialApi.patchPostLike("SNS", id)
        : socialApi.patchPostDislike("SNS", id);

      action
        .then((response) => {
          this.$hideLoading();
          //this.detail.like = !status;
        })
        .catch((err) => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    },
    changeTabType(ti, boardId) {
      let currentBoard = this.$route.query.bId;
      this.$route.query.bId = boardId;
      socialApi
        .boardAuth(this.boardId)
        .then((response) => {
          this.boardData = response.data.data;
          let permissionData = this.boardData.authPermission.find(
            (child) => child.partId == this.myId
          );
          if (permissionData) {
            this.selectedChild = permissionData;
          }
        })
        .catch((err) => {
          console.log("err", err);
          $state.error();
        });

      // this.$router.push("/socialLearning?bId=" + boardId);

      this.boardId = boardId;
      this.initData();
      this.getStaticData();
      this.learnViewTab = new MDCTabBar(
        document.querySelector("#learnViewTab")
      );
      this.learnViewTab.activateTab(ti);
    },
    getStaticData() {
      socialApi
        .fetchStaticList(this.boardId)
        .then((response) => {
          this.listData1 = response.data.data;
          if (this.contents.length > 0) {
            this.listData1 = [];
          }
        })
        .catch((err) => {
          $state.error();
        });
    },
  },
};
</script>
<style scoped>
/* reset */
.sm_star * {
  margin: 0;
  padding: 0;
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #222;
}

ol,
ul,
li {
  list-style: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}

th {
  font-weight: normal;
}

form,
fieldset,
iframe {
  display: block;
  border: 0;
}

img,
button {
  border: none;
  vertical-align: middle;
}

hr {
  height: 0;
  display: none;
}

i,
em,
address {
  font-style: normal;
}

label,
button {
  cursor: pointer;
}

blockquote,
q {
  quotes: none;
}

caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}

legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}

input:focus {
  outline: none;
}

::-webkit-input-placeholder {
  color: #999;
}

::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

a {
  color: #222;
  text-decoration: none;
}

a:link,
a:visited {
  text-decoration: none;
}

button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}

::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */
.sm_star {
  position: relative;
  margin: 0 auto;
}

.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 4;
  background-color: #fff;
  box-shadow: none !important;
}

.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 20px;
  font-weight: normal;
  height: 55px;
  line-height: 55px;
}

.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}

.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}

.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}

.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}

.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}

.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .back_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/back_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .more_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/more_btn.png) center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}

.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}

.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  border-radius: 4px;
  display: none;
}

.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}

.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}

.search_box .search_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/close_btn.svg) center center no-repeat;
  background-size: 22px auto;
  text-indent: -9999px;
}

.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */
.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}

.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}

.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}

.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}

.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}

.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}

.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */
.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}

.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}

.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}

.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}

.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* user */
.user_box {
  position: relative;
}

.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
  background-size: cover !important;
  aspect-ratio: 1/1;
}

.user_box .user_img img {
  /* width: auto;
  height: auto; */
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
  display: inline-block;
  line-height: 1.25em;
  letter-spacing: -0.05em !important;
}
.top-name {
  margin-top: 4px;
}

.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}

.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}

.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}

.user_box .user_write .write_btn {
  font-size: 12px;
  color: #acb4be;
  padding-top: 28px;
  background: url(/images/write_icon.png) center top no-repeat;
}

.user_box .user_write .write_btn.me {
  background: url(/images/my_write_icon.png) center top no-repeat;
}

.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}

.user_fixed {
  position: fixed;
  left: 0;
  top: 103px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 3;
}

/* style */
.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
}

.sm_list {
  position: relative;
}

.sm_list.view {
  padding-bottom: 85px;
}

.sm_list.learning {
  padding: 145px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}

.sm_list_box {
  position: relative;
}

.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}

.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}

.sm_list .no_data .no_img img {
  max-width: 120px;
}

.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}

.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}

.list_box .user_con {
  padding: 15px 0 0 0;
}

.list_box .user_tag {
  padding: 10px 0 0 0;
}

.list_box .user_opt {
  margin: 20px 0 0 0;
}

.list_box .user_imgList {
  margin: 20px 0 0 0;
}

.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}

.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}

.user_tag {
  position: relative;
  font-size: 0;
}

.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}

.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}

.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}

.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
}

.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}

.list_btn a.like {
  color: #818181 !important;
  background-image: url(/images/like_btn.png);
}

.list_btn a.like.on {
  color: #448aff !important;
  background-image: url(/images/like_btn_on.png);
}

.list_btn a.reply {
  background-image: url(/images/reply_btn.png);
}

.list_btn a.share {
  background-image: url(/images/share_btn.png);
}

.user_imgList {
  position: relative;
  font-size: 0;
}

.user_imgList a {
  display: inline-block;
  position: relative;
}

.user_imgList a img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}

.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}

.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}

.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}

.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}

.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}

.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
}

.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}

.user_imgList.reply a img {
}

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}

.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}

.reply_box {
  position: relative;
  margin-bottom: 15px;
}

.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}

.reply_box .user_box .more_btn {
  width: 22px;
  height: 22px;
  background: url(/images/reply_more_btn.png) center center no-repeat;
  background-size: 22px auto;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-indent: -9999px;
}

.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}

.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}

.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 50;
  padding: 15px 15px 20px 15px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}

.comment_area {
  position: relative;
}

.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}

.comment_area .picture_btn {
  background: url(/images/picture_btn.png) center center no-repeat;
  background-size: 22px auto;
  position: relative;
}

.comment_area .comment_btn {
  background: url(/images/comment_btn.png) center center no-repeat;
  background-size: 22px auto;
  right: 0;
}

.comment_area .comment_btn.on {
  background: url(/images/comment_btn_on.png) center center no-repeat;
  background-size: 22px auto;
}

.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}

.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}

.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}

.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}

.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.user-name-wrapper {
  width: calc(100% - 160px);
}

.name-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 180px;
}

.mdc-tab {
  padding: 0 24px !important;
  font-size: 13px !important;
  text-transform: none !important;
}
</style>
